<div *ngIf="!isloggedIn">
    <div class="page-wrapper">
        <app-public-header [title]="title"></app-public-header>
        <div class="page-body-wrapper">
            <div class="main-header-left d-none d-lg-block" style="padding: 0px">
                <div class="logo-wrapper"><a [routerLink]="'/'">
                        <img class="blur-up lazyloaded" src="../../../../assets/images/anre-logo-icon.png" alt=""></a>
                </div>
            </div>
            <div class="page-body" style="margin: 0px;">
                <app-public-comparator [isLoggedIn]="false"></app-public-comparator>
            </div>
            <footer class="footer">
                <app-public-footer></app-public-footer>
            </footer>
        </div>
    </div>
</div>

<app-public-comparator [isLoggedIn]="true" *ngIf="isloggedIn"></app-public-comparator>